import { EstimatedTax } from "./estimated-tax.interface"
export const mapMagentoTaxResponseToEstimatedTax = (magentoTaxResponse) => {

    const estimatedTax: EstimatedTax = {
        ...magentoTaxResponse,
        totalTax: {
            amount: magentoTaxResponse.tax,
        },
    }

    return estimatedTax;
}